import { makeXeroLink } from '@local_modules/generic/xero/utilities/xero-links.js'
import { ButtonsGroup } from '@local_modules/generic/web-paint/components/index.js'

import DataEntities from './data-entities/data-entities.js'
import loadLedgerAccounts from './db-data/load-ledger-accounts.js'
import loadFinancialStatement from './db-data/load-financial-statement.js'

/**
 * TODO: pick account:
 * const apiUrl = '/api/app-account/list'
 * const responseData = await callApi(apiUrl)
 */
export default class PickEntity {
  constructor () {
    console.log('PickEntity constructor')

    this.htmlTemplate = `
      <wp-card>
        <header>
          <h2>Pick Entity</h2>
        </header>
        <section>
          <wp-container id="entities-listing">Pending data...</wp-container>
        </section>
        <footer>
          <wp-container class="as-row">
            <wp-button id="connect-xero-button" data-color="primary">Connect Xero</wp-button>
            <wp-button id="go-to-xero-button" data-color="info" data-disabled>Go to Xero</wp-button>
          </wp-container>
        </footer>
      </wp-card>
    `

    this.mountedOn = null
    this.dataEntities = new DataEntities()
    this.selectedEntity = null
  }

  mount (element) {
    console.log('PickEntity mount')
    element.innerHTML = this.htmlTemplate
    this.mountedOn = element

    addListeners(this)
  }

  async loadEntities (appAccountId) {
    console.log('PickEntity loadData', appAccountId)
    this.appAccountId = appAccountId
    await this.dataEntities.initForAccount(appAccountId)

    console.log('PickEntity dataEntities', this.dataEntities)
  }

  render () {
    render(this)
  }

  async loadLedgerAccounts () {
    return await _loadLedgerAccounts(this)
  }

  async loadFinancialStatement () {
    return await _loadFinancialStatement(this)
  }
}

function render (instance) {
  console.log('PickEntity render')
  if (!instance.mountedOn) return

  if (!instance.dataEntities.data) return
  if (instance.dataEntities.data.length === 0) return

  const buttonsGroup = new ButtonsGroup({
    buttonsOptions: instance.dataEntities.data.map(entity => ({ label: entity.name, value: entity.id, toggable: true })),
    selectionType: 'single'
  })

  instance.mountedOn.querySelector('#entities-listing').innerHTML = ''
  instance.mountedOn.querySelector('#entities-listing').appendChild(buttonsGroup)

  buttonsGroup.addEventListener('wb:onSelectionChange', async (event) => {
    instance.mountedOn.querySelector('#go-to-xero-button').removeAttribute('data-disabled')

    console.log('wb:onSelectionChange', event)
    console.log('selected', event.detail.selected)
    console.log('value', event.detail.value)
    instance.selectedEntity = event.detail.value
    instance.mountedOn.dispatchEvent(new CustomEvent('pp:onEntitySelectionChange', {
      detail: {
        accountingOrganisationId: instance.selectedEntity
      }
    }))

    const [ledgerAccounts, financialStatement] = await Promise.all([instance.loadLedgerAccounts(), instance.loadFinancialStatement()])
    console.log('ledgerAccounts', ledgerAccounts)
    console.log('financialStatement', financialStatement)

    instance.mountedOn.dispatchEvent(new CustomEvent('pp:loadedLedgerAccountsAndFinancialStatement', {
      detail: {
        ledgerAccounts,
        financialStatement
      }
    }))
  })

  instance.mountedOn.querySelector('#connect-xero-button').addEventListener('wp:onClick', async (event) => {
    console.log('wp:onClick', event)
    const data = await fetch('/api/xero-api/consent-url')
    console.log('data', data)
    const dataJson = await data.json()
    console.log('dataJson', dataJson)
    location.href = dataJson.consentUrl
    // location.href = data.consentUrl
  })
}

function addListeners (instance) {
  instance.mountedOn.querySelector('#go-to-xero-button').addEventListener('wp:onClick', async (event) => {
    console.log('wp:onClick', event)

    console.log('instance.selectedEntity', instance.selectedEntity)
    console.log('instance.dataEntities.data', instance.dataEntities.data)

    const xeroLink = makeXeroLink('Bills', {
      shortCode: instance.dataEntities.data.find(entity => entity.id === instance.selectedEntity).xero_shortcode
    })
    window.open(xeroLink, '_blank').focus()
  })
}

async function _loadFinancialStatement (instance) {
  const accountingOrganisationId = instance.selectedEntity
  const financialStatement = await loadFinancialStatement(accountingOrganisationId)
  console.log('financialStatement', financialStatement)
  instance.financialStatement = financialStatement

  return financialStatement
}

async function _loadLedgerAccounts (instance) {
  const accountingOrganisationId = instance.selectedEntity
  const ledgerAccounts = await loadLedgerAccounts(accountingOrganisationId)
  console.log('ledgerAccounts', ledgerAccounts)
  instance.ledgerAccounts = ledgerAccounts

  instance.mountedOn.dispatchEvent(new CustomEvent('pp:onLedgerAccountsLoaded', {
    detail: { ledgerAccounts: instance.ledgerAccounts }
  }))

  return ledgerAccounts
}
